module.exports = __webpack_public_path__ + "img/HomeMAC1100.c0cb7a42.png";